export const getBySelector = (selector: string): HTMLElement | null => {
  return document.querySelector(selector);
};

export const getAllBySelectorRegExp = (selector: string): HTMLElement[] => {
  const nodes = document.querySelectorAll(selector);
  return nodes ? Array.from(nodes).map((node) => node as HTMLElement) : [];
};

export const getBySelectorRegExp = (selector: string): HTMLElement | null => {
  const elements = getAllBySelectorRegExp(selector);
  return elements.length > 0 ? (elements[0] as HTMLElement) : null;
};

export const showCookieConsentAction = (show: boolean) => {
  const el = getBySelector("#cc-preferences-button");

  if (el) {
    el.style.display = show ? "flex" : "none";
  }
};

export const showIntercomAction = (show: boolean) => {
  const el = getBySelector(".intercom-launcher");

  if (el) {
    el.style.display = show ? "flex" : "none";
  }
};

export const showVideoAskModal = (show: boolean) => {
  const button = getBySelector("#ask-video-modal-button");

  const modals = getAllBySelectorRegExp(
    'button[class^="videoask-embed__button--"]'
  );

  modals.forEach((modal) => (modal.style.display = show ? "flex" : "none"));

  if (button) {
    button.style.display = show ? "flex" : "none";
  }

  showIntercomAction(
    modals.some((modal) => modal.style.display !== "none") ? false : show
  );
};
